import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionSizeModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Name", fieldType: "text" },
    displayLabel: { label: "Display Label", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  displayLabel!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("displayLabel", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product size metadata");
    this.name = readString(source, "name");
    this.displayLabel = readString(source, "displayLabel");
    this.extra = splitKnown(source, ["name", "displayLabel"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.name ? { name: this.name } : {}),
      ...(this.displayLabel ? { displayLabel: this.displayLabel } : {}),
    };
  }
}
